import { useEffect, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import { getEntityIdByConfigurationMode } from '@/configuration/pages/ConfigurationPage/helpers'

import { servicesByConfigurationMode } from './constants'

const useEmailTemplatesList = ({ configurationMode, merchantId, returnPortalId }) => {
  const services = servicesByConfigurationMode[configurationMode || configurationTypes.returnsPortal]
  const entityId = getEntityIdByConfigurationMode({ configurationMode, merchantId, returnPortalId })

  const [accumulatedResults, setAccumulatedResults] = useState([])
  const [currentMode, setCurrentMode] = useState(configurationMode)

  const {
    data: emailTemplatesData,
    fetchData: fetchEmailTemplates,
    loading,
  } = useFetch(services.getEmailTemplates, {
    doInitialRequest: false,
    params: entityId,
  })

  useEffect(() => {
    if (emailTemplatesData?.results) {
      setAccumulatedResults(emailTemplatesData.results)
    }
  }, [emailTemplatesData])

  useEffect(() => {
    if (configurationMode && !emailTemplatesData && !loading) {
      fetchEmailTemplates(entityId)
    }
  }, [configurationMode, emailTemplatesData, loading])

  useEffect(() => {
    if (currentMode && configurationMode !== currentMode) {
      fetchEmailTemplates(entityId)
    }
    setCurrentMode(configurationMode)
  }, [configurationMode, currentMode])

  const refetch = () => {
    fetchEmailTemplates(entityId)
  }

  return {
    emailTemplates: accumulatedResults,
    setEmailTemplates: setAccumulatedResults,
    loading,
    enabledPortalsWithGlobal: emailTemplatesData?.enabled_portals || [],
    refetch,
  }
}

export default useEmailTemplatesList
